const MINIMUM_FIAS_LVL = 7
const MINIMUM_CUSTOMER_FIAS_LVL = 8
export const getIsAddressDetailed = (fiasLevel?: number | string): boolean =>
  Number(String(fiasLevel)[0]) >= MINIMUM_FIAS_LVL

export const getIsCustomerAddressDetailed = (fiasLevel?: number | string): boolean =>
  Number(String(fiasLevel)[0]) >= MINIMUM_CUSTOMER_FIAS_LVL
